import styled from "styled-components";
import {Button, Flex, Text} from "../../../components";

const ModalContainer = styled(Flex)`
  background: rgba(16, 18, 37, 0.75);
  justify-content: center;
  position: fixed; 
  top: 0; 
  left: 0; 
  bottom: 0; 
  right: 0;
  z-index: 1000;
  max-height: ${props => props.maxHeight ? props.maxHeight : ''};
  width: ${props => props.width ? props.width : ''};
`;

const Modal = styled(Flex)`
  max-width: ${props => props.maxWidth ? props.maxWidth : '420px'};
  margin: 5%;
  width: 100%;
  padding: 24px;
  border-radius: 8px;
  background: #161930;
  max-height: ${props => props.maxHeight ? props.maxHeight : ''};
`;

const Label = styled(Text.Body)`
  font-size: 12px;
  font-weight: 600;
`;

const ModalButton = styled(Button)`
  width: ${props => props.w ? props.w : '50%'};
  height: 48px;
  font-size: 16px;
`;

const Toggle = styled(Flex)`
  align-items: center;
  border-radius: 4px;
  height: 48px;
  width: 50%;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  transition: .2s ease;
  ${props => props.active
  ? `
      background: #272C4F;
      border: 1px solid #8A45FF;
    `
  : `
      background: #202441;
      color: #7178B2;  
    `
}
  &:hover {
    opacity: 0.8;
  }
  &:active {
    transform: scale(0.95);
  }
`;

const Select = styled.select`
  border: 0;
  outline: 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  height: 48px;
  padding: 0 16px;
  background: #202441;
  color: #fff;
  width: 100%;
  option {
    background: #202441;
    color: #fff;
  }
`;

const Input = styled.input`
  border: 0;
  outline: 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  height: 48px;
  padding: 0 16px;
  background: #202441;
  color: #fff;
  ${props => props.display ?
  `display: ${props.display};` : ``
  }
  width: 100%;
  ::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }
`;

const TextArea = styled.textarea`
  border: 0;
  outline: 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  padding: 16px;
  background: #202441;
  color: #fff;
  width: 100%;
  resize: none;
  height: ${props => props.height ? props.height : ''};
`;

export {
  Input,
  Select,
  ModalButton,
  Modal,
  ModalContainer,
  Toggle,
  Label,
  TextArea
}
